export default __webpack_public_path__ + "static/media/awaiting1.bab5653f.svg";